export default function stockMessage(node) {
  try {
    const international =
      Shopify.country && Shopify.country != "US" ? true : false;

    const quantity = international
      ? parseInt(node.inventoryReno?.value, 10)
      : node.quantityAvailable;

    let oos =
      node.preorder?.value === "true"
        ? node.oosMessage?.value
        : quantity > 0
          ? "In Stock"
          : node.oosMessage?.value;

    oos = oos ? oos : node.availableForSale ? "Briefly out of stock, ships soon" : "Not Available";

    return oos;
  } catch (error) {
    console.warn("Error generating stock message for", node, error);
    return null;
  }
}
